import { render, staticRenderFns } from "./RefundCommercialGesture.vue?vue&type=template&id=e94cd220"
import script from "./RefundCommercialGesture.vue?vue&type=script&lang=js"
export * from "./RefundCommercialGesture.vue?vue&type=script&lang=js"
import style0 from "./RefundCommercialGesture.vue?vue&type=style&index=0&id=e94cd220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports